import { handleExpiredTokens } from 'api/apiReqSagaCreator/httpRequest';
import { JsonPatch } from 'api/types/jsonPatch';
import { OdataURLBuilder } from 'api/types/OdataURLBuilder';
import {
  ApiResponseAsync,
  translateAxiosErrorToApiError,
} from 'container/models';

import BaseRepo from '../../BaseRepo';
import {
  IIndexingSourcesRepo,
  IndexingSourceWithHypermedia,
} from './IIndexingSourcesRepo';

export class IndexingSourcesRepo
  extends BaseRepo
  implements IIndexingSourcesRepo
{
  searchIndexingSources = (
    request: OdataURLBuilder
  ): ApiResponseAsync<Array<IndexingSourceWithHypermedia>> =>
    handleExpiredTokens(() =>
      this.client.get<Array<IndexingSourceWithHypermedia>>(request.toString())
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);

  createIndexingSource = (
    processId: string,
    name: string,
    preserveSource: boolean
  ): ApiResponseAsync<IndexingSourceWithHypermedia> =>
    handleExpiredTokens(() =>
      this.client.post<IndexingSourceWithHypermedia>(
        `processes/${processId}/indexing-sources`,
        { name, preserveSource }
      )
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);

  updateIndexingSource = (
    requestURL: string,
    patches: JsonPatch[]
  ): ApiResponseAsync<IndexingSourceWithHypermedia> =>
    handleExpiredTokens(() =>
      this.client.patch<IndexingSourceWithHypermedia>(requestURL, patches)
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
}
